import React from 'react'
import { t } from 'ttag'
import { Form } from 'components/shared/Form/Form'
import { Modal } from 'components/shared/Modal/Modal'
import { useModal, NAME_FIELD, MEMBERS_FIELD } from './hooks'
import styles from './DepartmentManagerModal.module.scss'
import * as R from 'ramda'

import { MAX_NAME_CHARACTERS } from './schema'

export const DepartmentManagerModal = ({
  department,
  onCancel,
  onClose,
  onConfirm,
  isOpen,
}) => {
  const {
    state: { control, formState, members },
    handlers: { handleCancel, handleClose, watch, handleFormSubmit },
  } = useModal({ department }, { onCancel, onClose, onConfirm })

  return (
    <Modal
      cancelLabel={t`Cancel`}
      confirmLabel={t`Save`}
      title={R.isNil(department?.id) ? t`Add department` : t`Edit department`}
      className={styles.modal}
      {...{
        onCancel: handleCancel,
        onClose: handleClose,
        onConfirm: handleFormSubmit,
        isOpen,
      }}
    >
      <Modal.Header />
      <Modal.Content className={styles.content}>
        <Form>
          <Form.Field
            error={formState.errors[NAME_FIELD]?.message}
            key={NAME_FIELD}
            field={'input'}
            label={t`Name`}
            limit={MAX_NAME_CHARACTERS}
            name={NAME_FIELD}
            isRequired
            control={control}
            count={watch(NAME_FIELD)?.length}
          />
          <Form.Field
            error={formState.errors[MEMBERS_FIELD]?.message}
            key={MEMBERS_FIELD}
            field={'combobox'}
            label={t`Member access`}
            name={MEMBERS_FIELD}
            placeholder={''}
            isRequired
            control={control}
            options={members.map(({ first_name, last_name, id }) => ({
              value: id,
              label: first_name ? `${first_name} ${last_name}` : ' - ',
            }))}
            isMulti
            isSearchable
            closeMenuOnSelect={false}
          />
        </Form>
      </Modal.Content>
      <Modal.Footer />
    </Modal>
  )
}
